export enum Plec {
  MEZCZYZNA = 'MEZCZYZNA',
  KOBIETA = 'KOBIETA',
}

export const PLEC_LABELS: Record<Plec, string> = {
  [Plec.MEZCZYZNA]: 'Mężczyzna',
  [Plec.KOBIETA]: 'Kobieta',
};

export function getGenderDropdownItems() {
  return Object.entries(PLEC_LABELS).map(([key, label]) => ({
    label,
    value: key as Plec,
  }));
}
